import { Add, Delete } from "@mui/icons-material";
import { Button, Stack, Typography } from "@mui/material";
import React from "react";
import { useFieldArray } from "react-hook-form";
import ConfigClassificationQuery from "./ConfigClassificationQuery";
import ConfigClassificationRoutedQuery from "./ConfigClassificationRoutedQuery";
import {
  defaultClassificationQuery,
  defaultClassificationRoutedQuery,
} from "./ConfigDefault";
import { useFormConfigContext } from "./ConfigFormContext";

const ConfigClassification: React.FC = () => {
  const { control, setValue, watch } = useFormConfigContext();

  const {
    fields: classificationQueries,
    append: addQuery,
    remove: removeQuery,
  } = useFieldArray({
    control,
    name: "config.classification.queries",
  });

  const addSimpleQuery = () => addQuery(defaultClassificationQuery());
  const addRoutedQuery = () => addQuery(defaultClassificationRoutedQuery());

  const split = watch("config.split");

  let routes =
    split?.segmentation.classes?.map((classe) => `split.${classe.name}`) || [];
  split?.segmentation.default && routes.push(split?.segmentation.default.name);

  return (
    <>
      <div className="flex justify-between items-center">
        <Typography className="text-xl font-semibold">
          Classification
        </Typography>
        <div className="flex gap-2">
          <Button
            className="gap-2"
            onClick={addSimpleQuery}
            variant="contained"
          >
            <Add />
            Classification
          </Button>
          <Button
            className="gap-2"
            variant="contained"
            onClick={addRoutedQuery}
            disabled={routes.length < 1}
          >
            <Add />
            Groupe
          </Button>
          <Button
            color="error"
            onClick={() => setValue("config.classification", undefined)}
          >
            <Delete />
          </Button>
        </div>
      </div>
      <Stack rowGap={2} className="py-4 px-4 overflow-y-scroll">
        {classificationQueries?.map((query, index) => {
          if (!query.hasOwnProperty("queries")) {
            return (
              <ConfigClassificationQuery
                index={index}
                removeQuery={() => removeQuery(index)}
                key={query.id}
              />
            );
          } else {
            return (
              <ConfigClassificationRoutedQuery
                index={index}
                removeRouted={() => removeQuery(index)}
                routes={routes}
                key={query.id}
              />
            );
          }
        })}
      </Stack>
    </>
  );
};
export default ConfigClassification;
